"use client";

import { cn } from "@/shared/lib/utils";
import { HEADER_VERTICAL_RAIL_OFFSET_PX } from "@/shared/types/header-layout";
import { useHeaderLayout } from "@/shared/ui/header-layout-init";

interface HeaderLayoutWrapperProps {
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function HeaderLayoutWrapper({
  header,
  children,
  className,
}: HeaderLayoutWrapperProps) {
  const layout = useHeaderLayout();

  const isVertical = layout === "left" || layout === "right";
  const isBottom = layout === "bottom";

  if (isVertical) {
    const railPad =
      layout === "left"
        ? { paddingLeft: HEADER_VERTICAL_RAIL_OFFSET_PX }
        : { paddingRight: HEADER_VERTICAL_RAIL_OFFSET_PX };
    return (
      <div
        className={cn(
          "min-h-screen relative flex",
          layout === "right" && "flex-row-reverse",
          className,
        )}
      >
        {header}
        <div className="flex-1 min-w-0 flex flex-col" style={railPad}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "min-h-screen relative flex flex-col",
        isBottom && "flex-col-reverse",
        className,
      )}
    >
      {header}
      {children}
    </div>
  );
}
